import { createTheme } from '@material-ui/core';
import createDefaultTheme from './default';

const typography = {
  fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
  h1: {
    fontSize: '3rem',
    fontWeight: 600,
    letterSpacing: '-0.02em',
  },
  h2: {
    fontSize: '2rem',
    fontWeight: 600,
    letterSpacing: '-0.01em',
  },
  h3: {
    fontSize: '1.64rem',
    fontWeight: 600,
  },
  h4: {
    fontSize: '1.5rem',
    fontWeight: 600,
  },
  h5: {
    fontSize: '1.285rem',
    fontWeight: 600,
  },
  h6: {
    fontSize: '1.142rem',
    fontWeight: 600,
  },
  button: {
    textTransform: 'none',
    fontWeight: 500,
  },
};

export const buildTheme = (mode = 'light') => {
  const base = createDefaultTheme(mode);
  return createTheme({
    ...base,
    typography: {
      ...(base.typography || {}),
      ...typography,
    },
  });
};

const themes = {
  default: buildTheme('light'),
};

export default themes;
